import { CoverImage } from '@seek/branding-assets';

import { Bleed, Box, Loader, Stack } from 'braid-design-system';
import { type CompanyProfile } from '../../../';

import { Section } from '../../common/section/Section';

import { CompanyProfileSummary } from './CompanyProfileSummary';

export type CompanyBrandingSectionModel = Pick<
  CompanyProfile,
  'branding' | 'name' | 'rating' | 'id' | 'zone'
>;

interface Props {
  aboutPageLink: string;
  navigateToAboutTab: () => void;
  navigateToReviewsTab: () => void;
  trackWriteAReviewClicked: () => void;
  loading?: boolean;
  model?: Omit<CompanyBrandingSectionModel, 'id'>;
}

const createImageObject = (propertyName: string, imageUrl?: string) => ({
  url: imageUrl || '',
  strategies: {
    [propertyName]: imageUrl || '',
  },
  id: imageUrl || '',
});

function CompanyProfileBanner({
  model,
}: {
  model?: Omit<CompanyBrandingSectionModel, 'id'>;
}) {
  const coverImageAsset = createImageObject(
    'jdpCover',
    model?.branding?.coverImageUrl,
  );

  return (
    <Bleed
      horizontal={{ mobile: 'xsmall', tablet: 'none', desktop: 'large' }}
      top="large"
    >
      <CoverImage cover={coverImageAsset} roundedCorners />
    </Bleed>
  );
}

/**
 * This is a view mode component
 */
export function CompanyBrandingSection({
  model,
  loading,
  navigateToReviewsTab,
  navigateToAboutTab,
  trackWriteAReviewClicked,
  aboutPageLink,
}: Props) {
  if (loading) {
    return <Loader />;
  }

  return (
    <Section mode="view" loading={loading}>
      <Box paddingBottom="small">
        <Stack space="large">
          <CompanyProfileBanner model={model} />
          <CompanyProfileSummary
            model={model}
            aboutPageLink={aboutPageLink}
            navigateToAboutTab={navigateToAboutTab}
            navigateToReviewsTab={navigateToReviewsTab}
            trackWriteAReviewClicked={trackWriteAReviewClicked}
          />
        </Stack>
      </Box>
    </Section>
  );
}
